// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.change-password-modal {
  width: var(--login-modal-width-tablet) !important;
}
@media (min-width: 1200px) {
  div.change-password-modal {
    width: var(--login-modal-width-desktop) !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/modals/ChangePasswordModal/ChangePasswordModal.scss"],"names":[],"mappings":"AAEA;EAEI,iDAAA;AAFJ;AAII;EAJJ;IAKQ,kDAAA;EADN;AACF","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
